<template>
    <section class="py-2">
        <div class="w-11/12 mx-auto">
            <p class="text-sm text-gray-600 dark:text-gray-300 uppercase">Recolha dos últimos três meses</p>
            <div v-if="ultimasRecolhas.length === 0" class="w-full h-20 rounded-lg mt-4 flex items-center">
                <p class="text-xl text-gray-500 dark:text-gray-300 ml-4 text-center w-full">Esse loja não possui recolhas prévias</p>
            </div>
            <div v-for="r, i in ultimasRecolhas" :key="i" class="w-full bg-gray-100 dark:bg-gray-800 h-20 rounded-lg border border-gray-300 dark:border-gray-700 mt-4 flex px-8 justify-between">
                <div class="flex flex-col items-center my-auto ">
                    <p class="text-gray-500 dark:text-gray-200 text-xs uppercase">Recolha realizada em:</p>
                    <p class="text-indigo-500 dark:text-indigo-300 text-base">{{dataMask(r.recolha.pesquisa_realizada_em).split(' ')[0]}} às {{horaMask(r.recolha.pesquisa_realizada_em)}}</p>
                </div>
                <div class="flex flex-col items-center my-auto ">
                    <p class="text-gray-500 dark:text-gray-200 text-xs uppercase">Ano mês</p>
                    <p class="text-indigo-500 dark:text-indigo-300 text-base">{{r.recolha.ano_mes.slice(0,4)+'/'+r.recolha.ano_mes.slice(4,6)}}</p>
                </div>
                <div class="flex items-center my-auto">
                    <p class="text-gray-500 dark:text-gray-200 text-xs uppercase">por: </p>
                    <div class="bg-indigo-400 rounded-full w-16 h-16 ml-4">
                        <img v-if="r.recolha.pesquisador.avatar" class="rounded-full " :src="r.recolha.pesquisador.avatar" alt="">
                        <span v-else class="h-full w-full flex text-gray-100"><p class="m-auto text-2xl">{{r.recolha.pesquisador.nome[0]}}{{r.recolha.pesquisador.nome.split(' ')[1][0]}}</p></span>
                    </div>
                    <p class="text-gray-500 dark:text-gray-200 ml-4">{{r.recolha.pesquisador.nome}}</p>
                </div>
                <div class="flex items-center my-auto">
                    <p class="text-gray-600 dark:text-gray-200 text-xs uppercase">Produtos: </p>
                    <p class="text-gray-600 dark:text-gray-200 ml-4">{{r.historico.length}}</p>
                </div>
                <div class="flex items-center my-auto">
                    <p :class="r.recolha.editavel === 'false' ? 'text-green-500 dark:text-green-300' : 'text-yellow-300'" class="ml-4">{{r.recolha.editavel === 'false' ? 'Finalizada' : 'Em progresso'}}</p>
                </div>
                <div class="flex items-center my-auto h-full">
                    <button @click="router.push({ name: 'DetalheRecolhas', params: { anomes: r.recolha.ano_mes }})" class="btn bg-indigo-500 text-gray-100 h-1/2 px-2 rounded-full">Detalhes</button>
                </div>
            </div>
        </div>
        <div class="mt-4 w-11/12 mx-auto">
            <p class="text-sm text-gray-600 dark:text-gray-300 uppercase">ou selecione um período</p>
            <DatePicker class="mt-4" v-model="anomes" />
        </div>
        <div class="w-11/12 mx-auto">
            <div v-if="hasRecolha" class="w-full bg-gray-100 dark:bg-gray-800 h-20 rounded-lg border border-gray-300 dark:border-gray-700 mt-4 flex px-8 justify-between">
                <div class="flex flex-col items-center my-auto ">
                    <p class="text-gray-500 dark:text-gray-200 text-xs uppercase">Recolha realizada em:</p>
                    <p class="text-indigo-500 dark:text-indigo-300 text-base">{{dataMask(recolha.recolha.pesquisa_realizada_em).split(' ')[0]}} às {{horaMask(recolha.recolha.pesquisa_realizada_em)}}</p>
                </div>
                <div class="flex flex-col items-center my-auto ">
                    <p class="text-gray-500 dark:text-gray-200 text-xs uppercase">Ano mês</p>
                    <p class="text-indigo-500 dark:text-indigo-300 text-base">{{recolha.recolha.ano_mes.slice(0,4)+'/'+recolha.recolha.ano_mes.slice(4,6)}}</p>
                </div>
                <div class="flex items-center my-auto">
                    <p class="text-gray-500 dark:text-gray-200 text-xs uppercase">por: </p>
                    <div class="bg-indigo-400 rounded-full w-16 h-16 ml-4">
                        <img v-if="recolha.recolha.pesquisador.avatar" class="rounded-full " :src="recolha.recolha.pesquisador.avatar" alt="">
                        <span v-else class="h-full w-full flex text-gray-100"><p class="m-auto text-2xl">{{recolha.recolha.pesquisador.nome[0]}}{{recolha.recolha.pesquisador.nome.split(' ')[1][0]}}</p></span>
                    </div>
                    <p class="text-gray-500 dark:text-gray-200 ml-4">{{recolha.recolha.pesquisador.nome}}</p>
                </div>
                <div class="flex items-center my-auto">
                    <p class="text-gray-500 dark:text-gray-200 text-xs uppercase">Produtos: </p>
                    <p class="text-gray-500 dark:text-gray-200 ml-4">{{recolha.historico.length}}</p>
                </div>
                <div class="flex items-center my-auto">
                    <p :class="recolha.recolha.editavel === 'false' ? 'text-green-500 dark:text-green-300' : 'text-yellow-300'" class="ml-4">{{recolha.recolha.editavel === 'false' ? 'Finalizada' : 'Em progresso'}}</p>
                </div>
                <div class="flex items-center my-auto h-full">
                    <button @click="router.push({ name: 'DetalheRecolhas', params: { anomes: recolha.recolha.ano_mes }})" class="btn bg-indigo-500 text-gray-100 h-1/2 px-2 rounded-full">Detalhes</button>
                </div>
            </div>
            <div v-else class="w-full h-20 rounded-lg mt-4 flex items-center">
                <p v-if="anomes" class="text-xl text-gray-500 dark:text-gray-300 ml-4 text-center w-full">Sem recolha para esse período</p>
            </div>
        </div>
    </section>
</template>

<script>
import { ref } from '@vue/reactivity'
import { GET_RECOLHA_RECOLHA_BY_ANOMES } from '../../mixins/api'
import { cnpjMask as cnpj_mask, timeFormat, telephoneMask, dateTimeFormat } from '../../mixins/mask'
import DatePicker from '../Design/Datepicker.vue'
import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, watch } from '@vue/runtime-core'
export default {
    name: 'PesquisarRecolha',
    components: {
        DatePicker
    },

    setup () {
        const router = useRouter()

        const recolha = ref({})

        const ultimasRecolhas = ref([])

        const recolhaAtual = ref({})
        const recolhaPassed1 = ref({})
        const recolhaPassed2 = ref({})

        const route = useRoute()
        const produtoUltimaRecolha = ref('')
        const hasRecolha = ref(false)

        const date = new Date()

        const datePassed1 = new Date()
        datePassed1.setMonth(datePassed1.getMonth() - 1)
        const datePassed2 = new Date()
        datePassed2.setMonth(datePassed2.getMonth() - 2)

        const anomes = ref('')

        const anomesAtual = ref(date.getFullYear().toString() + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)))
        const anomesPassed1 = ref(datePassed1.getFullYear().toString() + ((datePassed1.getMonth() + 1) < 10 ? '0' + (datePassed1.getMonth() + 1) : (datePassed1.getMonth() + 1)))
        const anomesPassed2 = ref(datePassed2.getFullYear().toString() + ((datePassed2.getMonth() + 1) < 10 ? '0' + (datePassed2.getMonth() + 1) : (datePassed2.getMonth() + 1)))

        const cnpjMask = cnpj_mask
        const phoneMask = telephoneMask
        const horaMask = timeFormat
        const dataMask = dateTimeFormat

        onMounted(() => {
            GET_RECOLHA_RECOLHA_BY_ANOMES(route.params.id, anomesAtual.value).then(r => {
                recolhaAtual.value = r.data.resultado
                if (!Array.isArray(recolhaAtual.value)) {
                    ultimasRecolhas.value.push(recolhaAtual.value)
                }
            })
            GET_RECOLHA_RECOLHA_BY_ANOMES(route.params.id, anomesPassed1.value).then(r => {
                recolhaPassed1.value = r.data.resultado
                if (!Array.isArray(recolhaPassed1.value)) {
                    ultimasRecolhas.value.push(recolhaPassed1.value)
                }
            })
            GET_RECOLHA_RECOLHA_BY_ANOMES(route.params.id, anomesPassed2.value).then(r => {
                recolhaPassed2.value = r.data.resultado
                if (!Array.isArray(recolhaPassed2.value)) {
                    ultimasRecolhas.value.push(recolhaPassed2.value)
                }
            })
        })

        const searchByAnoMes = () => {
            GET_RECOLHA_RECOLHA_BY_ANOMES(route.params.id, anomes.value).then(r => {
                recolha.value = r.data.resultado
                hasRecolha.value = Object.keys(recolha.value).length !== 0
            })
        }
        watch(() => anomes.value, (data, prev) => {
            searchByAnoMes()
            
        })

        const filteredultimaRecolhaProdutos = computed(() => {
            if (produtoUltimaRecolha.value === '') {
                return recolha.value.historico
            }
            const compl = recolha.value.historico.filter(x => x.complemento.toLowerCase().includes(produtoUltimaRecolha.value.toLowerCase()))
            const marca = recolha.value.historico.filter(x => x.marca.toLowerCase().includes(produtoUltimaRecolha.value.toLowerCase()))
            const modelo = recolha.value.historico.filter(x => x.modelo.toLowerCase().includes(produtoUltimaRecolha.value.toLowerCase()))
            if (compl.length > 0) { return compl } else if (marca.length > 0) { return marca } else if (modelo.length > 0) { return modelo }
        })
        return {
            recolha,
            ultimasRecolhas,
            recolhaAtual,
            recolhaPassed1,
            recolhaPassed2,
            filteredultimaRecolhaProdutos,
            produtoUltimaRecolha,
            hasRecolha,
            anomes,
            router,
            searchByAnoMes,
            cnpjMask,
            phoneMask,
            horaMask,
            dataMask
        }
    }
}
</script>

<style>

</style>
